import { z } from "zod";

export const zone = z.enum(["EXO", "STD", "EU", "BREXIT", "HT"]);

const baseCountry = z.object({
  mobileCountryCode: z.string(),
  searchTags: z.string(),
  displayName: z.object({
    id: z.number(),
    pl: z.string(),
  }),
  displayNameDeclined: z
    .object({
      id: z.number().optional(),
      pl: z.string().optional(),
    })
    .or(z.null())
    .optional(),
  flagImage: z
    .object({
      url: z.string().optional(),
      fileName: z.string().optional(),
    })
    .optional(),
  zones: z.array(
    z.object({
      name: zone,
      displayName: z.object({
        id: z.number(),
        pl: z.string(),
      }),
      isPromo: z.boolean(),
      priority: z.number(),
    }),
  ),
});

const identityCountry = baseCountry.merge(
  z.object({
    allowedForNationalIdentityCard: z.boolean().or(z.null()),
    allowedForPassport: z.boolean().or(z.null()),
    allowedForResidencePermit: z.boolean().or(z.null()),
    ISO_3166_1_alpha_3: z.string(),
  }),
);

export const identityCountries = z.array(identityCountry);
export const roamingInternationalCountries = z.array(baseCountry);

export type IRoamingInternationalCountry = z.infer<typeof baseCountry>;
export type IIdentityCountry = z.infer<typeof identityCountry>;
